import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { RootState } from '@share/utils';
import { IHotelInfo } from '@common-types';

import { RoomsSearchList } from '../rooms-search-list';
import { RoomsSearchSearch } from '../rooms-search-search';

import './style.scss';

interface IProps {
  hotel: IHotelInfo;
  refAnchor: React.RefObject<HTMLDivElement>;
  matches?: boolean;
  isVacationRentals?: boolean;
  isFocused?: boolean;
  isStaticDetail?: boolean;
}

export function RoomsSearch(props: IProps) {

  const roomsSearchStore = useSelector((state: RootState) => state.roomsSearchStore);
  const loginStore = useSelector((state: RootState) => state.loginStore);

  const { timer, error } = roomsSearchStore;
  const { account } = loginStore;

  useEffect(() => {
    return () => {
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, []);


  const isVacationRental = props.hotel.hotelDetails?.isVacationRental;
  const isAshevillePlay = account?.isAshevillePlay;

  return (
    <div className="rooms-search" ref={props.refAnchor}>
      {!isAshevillePlay && (
        <div className="rooms-search__header secondary-font">
          <FormattedMessage id={isVacationRental ? "property.availability" : "rooms.availability"} />
        </div>)}

      <div className="rooms-search__search-wrapper">
        <RoomsSearchSearch
          hotel={props.hotel}
          refAnchor={props.refAnchor}
          matches={props.matches}
          isVacationRentals={props.isVacationRentals}
          isFocused={props.isFocused}
          isStaticDetail={props.isStaticDetail}
        />

        {!isAshevillePlay && error && (
          <div className="date-picker__error" title={error} style={{ marginTop: '5px' }}>
            {error}
          </div>)}

        <RoomsSearchList
          hotel={props.hotel}
          isVacationRentals={props.isVacationRentals}
          isStaticDetail={props.isStaticDetail}
          isFocused={props.isFocused}
        />
      </div>

    </div>
  );
}
